export const botGuidelinesTabBlankslate = (
  <svg width="100%" height="669" viewBox="0 0 1794 669" fill="none">
    <rect width="1794" height="56" fill="#EFF3F8" />
    <rect x="1288" y="15.5" width="175" height="17" rx="8.5" fill="#E8E8E8" />
    <circle cx="1488" cy="24" r="12.5" fill="#EFF3F8" stroke="#E6E6E6" />
    <g clipPath="url(#clip0_4824_4737)">
      <path
        d="M1488.59 18.4302L1483.15 23.8771L1488.59 29.3236"
        stroke="#BCBDC3"
        strokeWidth="1.3"
      />
    </g>
    <g clipPath="url(#clip1_4824_4737)">
      <path
        d="M1493.2 18.4302L1487.75 23.8771L1493.2 29.3236"
        stroke="#BCBDC3"
        strokeWidth="1.3"
      />
    </g>
    <circle cx="1520" cy="24" r="12.5" fill="#EFF3F8" stroke="#E6E6E6" />
    <g clipPath="url(#clip2_4824_4737)">
      <path
        d="M1522.38 18.4656L1516.93 23.9125L1522.38 29.359"
        stroke="#BCBDC3"
        strokeWidth="1.3"
      />
    </g>
    <line
      x1="1546"
      y1="13"
      x2="1546"
      y2="35"
      stroke="#E6E6E6"
      strokeWidth="2"
    />
    <path
      d="M1561.55 18.5781C1563.02 18.5781 1564.1 18.8672 1564.77 19.4453C1565.46 20.0182 1565.8 20.8411 1565.8 21.9141C1565.8 22.3984 1565.72 22.8594 1565.55 23.2969C1565.4 23.7292 1565.14 24.112 1564.79 24.4453C1564.43 24.7734 1563.97 25.0339 1563.39 25.2266C1562.82 25.4141 1562.11 25.5078 1561.28 25.5078H1559.89V30H1558.56V18.5781H1561.55ZM1561.42 19.7109H1559.89V24.3672H1561.13C1561.86 24.3672 1562.47 24.2891 1562.95 24.1328C1563.44 23.9766 1563.81 23.724 1564.05 23.375C1564.3 23.0208 1564.42 22.5521 1564.42 21.9688C1564.42 21.2083 1564.18 20.6432 1563.7 20.2734C1563.21 19.8984 1562.45 19.7109 1561.42 19.7109ZM1571.2 21.2969C1572.22 21.2969 1572.97 21.526 1573.47 21.9844C1573.96 22.4427 1574.21 23.1745 1574.21 24.1797V30H1573.27L1573.02 28.7344H1572.95C1572.71 29.0469 1572.46 29.3099 1572.2 29.5234C1571.94 29.7318 1571.64 29.8906 1571.3 30C1570.96 30.1042 1570.54 30.1562 1570.05 30.1562C1569.53 30.1562 1569.06 30.0651 1568.66 29.8828C1568.26 29.7005 1567.94 29.4245 1567.7 29.0547C1567.47 28.6849 1567.36 28.2161 1567.36 27.6484C1567.36 26.7943 1567.7 26.138 1568.38 25.6797C1569.05 25.2214 1570.08 24.9714 1571.47 24.9297L1572.95 24.8672V24.3438C1572.95 23.6042 1572.79 23.0859 1572.47 22.7891C1572.15 22.4922 1571.7 22.3438 1571.12 22.3438C1570.68 22.3438 1570.25 22.4089 1569.84 22.5391C1569.44 22.6693 1569.05 22.8229 1568.69 23L1568.29 22.0156C1568.67 21.8177 1569.12 21.6484 1569.62 21.5078C1570.12 21.3672 1570.64 21.2969 1571.2 21.2969ZM1572.93 25.7812L1571.62 25.8359C1570.56 25.8776 1569.8 26.0521 1569.37 26.3594C1568.93 26.6667 1568.71 27.1016 1568.71 27.6641C1568.71 28.1536 1568.86 28.5156 1569.16 28.75C1569.45 28.9844 1569.85 29.1016 1570.34 29.1016C1571.1 29.1016 1571.72 28.8906 1572.2 28.4688C1572.69 28.0469 1572.93 27.4141 1572.93 26.5703V25.7812ZM1579.27 33.8438C1578.15 33.8438 1577.28 33.6328 1576.67 33.2109C1576.06 32.7943 1575.76 32.2083 1575.76 31.4531C1575.76 30.9167 1575.93 30.4583 1576.27 30.0781C1576.61 29.6979 1577.08 29.4453 1577.69 29.3203C1577.46 29.2161 1577.27 29.0599 1577.11 28.8516C1576.95 28.6432 1576.88 28.4036 1576.88 28.1328C1576.88 27.8203 1576.96 27.5469 1577.13 27.3125C1577.31 27.0729 1577.58 26.8438 1577.94 26.625C1577.49 26.4427 1577.12 26.1354 1576.84 25.7031C1576.57 25.2656 1576.43 24.7578 1576.43 24.1797C1576.43 23.5651 1576.56 23.0417 1576.81 22.6094C1577.07 22.1719 1577.44 21.8385 1577.92 21.6094C1578.41 21.3802 1578.99 21.2656 1579.68 21.2656C1579.83 21.2656 1579.98 21.2734 1580.13 21.2891C1580.29 21.2995 1580.44 21.3177 1580.58 21.3438C1580.72 21.3646 1580.84 21.3906 1580.95 21.4219H1583.88V22.2578L1582.3 22.4531C1582.46 22.6562 1582.59 22.901 1582.7 23.1875C1582.8 23.474 1582.85 23.7917 1582.85 24.1406C1582.85 24.9948 1582.56 25.6745 1581.98 26.1797C1581.41 26.6797 1580.61 26.9297 1579.6 26.9297C1579.36 26.9297 1579.12 26.9089 1578.87 26.8672C1578.61 27.0078 1578.42 27.1641 1578.28 27.3359C1578.15 27.5078 1578.09 27.7057 1578.09 27.9297C1578.09 28.0964 1578.14 28.2292 1578.23 28.3281C1578.34 28.4271 1578.49 28.5 1578.68 28.5469C1578.87 28.5885 1579.1 28.6094 1579.38 28.6094H1580.88C1581.82 28.6094 1582.53 28.8047 1583.02 29.1953C1583.52 29.5859 1583.77 30.1562 1583.77 30.9062C1583.77 31.8542 1583.39 32.5807 1582.62 33.0859C1581.85 33.5911 1580.73 33.8438 1579.27 33.8438ZM1579.31 32.8281C1580.02 32.8281 1580.61 32.7552 1581.07 32.6094C1581.54 32.4688 1581.89 32.263 1582.12 31.9922C1582.35 31.7266 1582.47 31.4089 1582.47 31.0391C1582.47 30.6953 1582.39 30.4349 1582.23 30.2578C1582.08 30.0859 1581.85 29.9714 1581.55 29.9141C1581.24 29.8516 1580.88 29.8203 1580.44 29.8203H1578.95C1578.57 29.8203 1578.23 29.8802 1577.95 30C1577.66 30.1198 1577.44 30.2969 1577.28 30.5312C1577.13 30.7656 1577.05 31.0573 1577.05 31.4062C1577.05 31.8698 1577.25 32.2214 1577.64 32.4609C1578.03 32.7057 1578.59 32.8281 1579.31 32.8281ZM1579.65 25.9844C1580.27 25.9844 1580.73 25.8281 1581.05 25.5156C1581.36 25.2031 1581.52 24.7474 1581.52 24.1484C1581.52 23.5078 1581.36 23.0286 1581.04 22.7109C1580.72 22.388 1580.25 22.2266 1579.63 22.2266C1579.04 22.2266 1578.58 22.3932 1578.26 22.7266C1577.94 23.0547 1577.78 23.5365 1577.78 24.1719C1577.78 24.7552 1577.94 25.2031 1578.27 25.5156C1578.59 25.8281 1579.05 25.9844 1579.65 25.9844ZM1588.87 21.2812C1589.6 21.2812 1590.22 21.4427 1590.74 21.7656C1591.26 22.0885 1591.66 22.5417 1591.94 23.125C1592.21 23.7031 1592.35 24.3802 1592.35 25.1562V25.9609H1586.44C1586.45 26.9661 1586.7 27.7318 1587.19 28.2578C1587.67 28.7839 1588.35 29.0469 1589.23 29.0469C1589.78 29.0469 1590.26 28.9974 1590.67 28.8984C1591.09 28.7995 1591.52 28.6536 1591.97 28.4609V29.6016C1591.54 29.7943 1591.11 29.9349 1590.68 30.0234C1590.26 30.112 1589.76 30.1562 1589.18 30.1562C1588.36 30.1562 1587.64 29.9896 1587.02 29.6562C1586.41 29.3177 1585.94 28.8229 1585.6 28.1719C1585.26 27.5208 1585.09 26.724 1585.09 25.7812C1585.09 24.8594 1585.25 24.0625 1585.55 23.3906C1585.87 22.7135 1586.3 22.1927 1586.87 21.8281C1587.43 21.4635 1588.1 21.2812 1588.87 21.2812ZM1588.85 22.3438C1588.16 22.3438 1587.61 22.5703 1587.2 23.0234C1586.78 23.4766 1586.54 24.1094 1586.46 24.9219H1590.99C1590.99 24.4115 1590.91 23.9635 1590.75 23.5781C1590.6 23.1875 1590.37 22.8854 1590.05 22.6719C1589.74 22.4531 1589.34 22.3438 1588.85 22.3438Z"
      fill="#4F4F4F"
    />
    <rect x="1598" y="15.5" width="98" height="17" rx="8.5" fill="#E8E8E8" />
    <line
      x1="1709"
      y1="13"
      x2="1709"
      y2="35"
      stroke="#E6E6E6"
      strokeWidth="2"
    />
    <circle
      cx="13"
      cy="13"
      r="12.5"
      transform="matrix(-1 0 0 1 1746 11)"
      fill="#EFF3F8"
      stroke="#E6E6E6"
    />
    <g clipPath="url(#clip3_4824_4737)">
      <path
        d="M1730.62 18.4656L1736.07 23.9125L1730.62 29.359"
        stroke="#BCBDC3"
        strokeWidth="1.3"
      />
    </g>
    <circle
      cx="13"
      cy="13"
      r="12.5"
      transform="matrix(-1 0 0 1 1778 11)"
      fill="#EFF3F8"
      stroke="#E6E6E6"
    />
    <g clipPath="url(#clip4_4824_4737)">
      <path
        d="M1764.41 18.4302L1769.85 23.8771L1764.41 29.3236"
        stroke="#BCBDC3"
        strokeWidth="1.3"
      />
    </g>
    <g clipPath="url(#clip5_4824_4737)">
      <path
        d="M1759.8 18.4302L1765.25 23.8771L1759.8 29.3236"
        stroke="#BCBDC3"
        strokeWidth="1.3"
      />
    </g>
    <rect x="16" y="20" width="145" height="17" rx="8.5" fill="#E8E8E8" />
    <mask id="path-17-inside-1_4824_4737" fill="white">
      <path d="M0 56H40V119H0V56Z" />
    </mask>
    <path d="M0 56H40V119H0V56Z" fill="#F6F6F6" />
    <path
      d="M0 56V55H-1V56H0ZM0 119H-1V120H0V119ZM0 57H40V55H0V57ZM40 118H0V120H40V118ZM1 119V56H-1V119H1Z"
      fill="#E6E6E6"
      mask="url(#path-17-inside-1_4824_4737)"
    />
    <rect
      x="12.5"
      y="80"
      width="15"
      height="15"
      rx="1.5"
      fill="white"
      stroke="#D6D5D5"
    />
    <mask id="path-20-inside-2_4824_4737" fill="white">
      <path d="M40 56H190V119H40V56Z" />
    </mask>
    <path d="M40 56H190V119H40V56Z" fill="#F6F6F6" />
    <path
      d="M40 57H190V55H40V57ZM190 118H40V120H190V118Z"
      fill="#E6E6E6"
      mask="url(#path-20-inside-2_4824_4737)"
    />
    <mask id="path-22-inside-3_4824_4737" fill="white">
      <path d="M56 79H174V96H56V79Z" />
    </mask>
    <path
      d="M173 79V96H175V79H173Z"
      fill="#E6E6E6"
      mask="url(#path-22-inside-3_4824_4737)"
    />
    <rect x="56" y="79" width="86" height="17" rx="8.5" fill="#E8E8E8" />
    <mask id="path-25-inside-4_4824_4737" fill="white">
      <path d="M190 56H1209V119H190V56Z" />
    </mask>
    <path d="M190 56H1209V119H190V56Z" fill="#F6F6F6" />
    <path
      d="M190 57H1209V55H190V57ZM1209 118H190V120H1209V118Z"
      fill="#E6E6E6"
      mask="url(#path-25-inside-4_4824_4737)"
    />
    <mask id="path-27-inside-5_4824_4737" fill="white">
      <path d="M206 79H1193V96H206V79Z" />
    </mask>
    <path
      d="M1192 79V96H1194V79H1192Z"
      fill="#E6E6E6"
      mask="url(#path-27-inside-5_4824_4737)"
    />
    <rect x="206" y="79" width="145" height="17" rx="8.5" fill="#E8E8E8" />
    <mask id="path-30-inside-6_4824_4737" fill="white">
      <path d="M1209 56H1419V119H1209V56Z" />
    </mask>
    <path d="M1209 56H1419V119H1209V56Z" fill="#F6F6F6" />
    <path
      d="M1209 57H1419V55H1209V57ZM1419 118H1209V120H1419V118Z"
      fill="#E6E6E6"
      mask="url(#path-30-inside-6_4824_4737)"
    />
    <mask id="path-32-inside-7_4824_4737" fill="white">
      <path d="M1225 79H1403V96H1225V79Z" />
    </mask>
    <path
      d="M1402 79V96H1404V79H1402Z"
      fill="#E6E6E6"
      mask="url(#path-32-inside-7_4824_4737)"
    />
    <rect x="1225" y="79" width="145" height="17" rx="8.5" fill="#E8E8E8" />
    <mask id="path-35-inside-8_4824_4737" fill="white">
      <path d="M1419 56H1629V119H1419V56Z" />
    </mask>
    <path d="M1419 56H1629V119H1419V56Z" fill="#F6F6F6" />
    <path
      d="M1419 57H1629V55H1419V57ZM1629 118H1419V120H1629V118Z"
      fill="#E6E6E6"
      mask="url(#path-35-inside-8_4824_4737)"
    />
    <mask id="path-37-inside-9_4824_4737" fill="white">
      <path d="M1435 79H1613V96H1435V79Z" />
    </mask>
    <path
      d="M1612 79V96H1614V79H1612Z"
      fill="#E6E6E6"
      mask="url(#path-37-inside-9_4824_4737)"
    />
    <rect x="1435" y="79" width="145" height="17" rx="8.5" fill="#E8E8E8" />
    <mask id="path-40-inside-10_4824_4737" fill="white">
      <path d="M1629 56H1794V119H1629V56Z" />
    </mask>
    <path d="M1629 56H1794V119H1629V56Z" fill="#F6F6F6" />
    <path
      d="M1794 56H1795V55H1794V56ZM1794 119V120H1795V119H1794ZM1629 57H1794V55H1629V57ZM1793 56V119H1795V56H1793ZM1794 118H1629V120H1794V118Z"
      fill="#E6E6E6"
      mask="url(#path-40-inside-10_4824_4737)"
    />
    <rect x="1663.5" y="79" width="92" height="17" rx="8.5" fill="#E8E8E8" />
    <mask id="path-43-inside-11_4824_4737" fill="white">
      <path d="M0 118H40V174H0V118Z" />
    </mask>
    <path d="M0 118H40V174H0V118Z" fill="white" />
    <path
      d="M0 118V117H-1V118H0ZM0 174H-1V175H0V174ZM0 119H40V117H0V119ZM40 173H0V175H40V173ZM1 174V118H-1V174H1Z"
      fill="#E6E6E6"
      mask="url(#path-43-inside-11_4824_4737)"
    />
    <rect
      x="12.5"
      y="138.5"
      width="15"
      height="15"
      rx="1.5"
      fill="white"
      stroke="#D6D5D5"
    />
    <mask id="path-46-inside-12_4824_4737" fill="white">
      <path d="M40 118H190V174H40V118Z" />
    </mask>
    <path d="M40 118H190V174H40V118Z" fill="white" />
    <path
      d="M40 119H190V117H40V119ZM190 173H40V175H190V173Z"
      fill="#E8E8E8"
      mask="url(#path-46-inside-12_4824_4737)"
    />
    <rect x="52" y="137.5" width="122" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-49-inside-13_4824_4737" fill="white">
      <path d="M190 118H1209V174H190V118Z" />
    </mask>
    <path d="M190 118H1209V174H190V118Z" fill="white" />
    <path
      d="M190 119H1209V117H190V119ZM1209 173H190V175H1209V173Z"
      fill="#E8E8E8"
      mask="url(#path-49-inside-13_4824_4737)"
    />
    <rect x="202" y="137.5" width="795" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-52-inside-14_4824_4737" fill="white">
      <path d="M1209 118H1419V174H1209V118Z" />
    </mask>
    <path d="M1209 118H1419V174H1209V118Z" fill="white" />
    <path
      d="M1209 119H1419V117H1209V119ZM1419 173H1209V175H1419V173Z"
      fill="#E8E8E8"
      mask="url(#path-52-inside-14_4824_4737)"
    />
    <rect x="1221" y="137.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-55-inside-15_4824_4737" fill="white">
      <path d="M1419 118H1629V174H1419V118Z" />
    </mask>
    <path d="M1419 118H1629V174H1419V118Z" fill="white" />
    <path
      d="M1419 119H1629V117H1419V119ZM1629 173H1419V175H1629V173Z"
      fill="#E8E8E8"
      mask="url(#path-55-inside-15_4824_4737)"
    />
    <rect x="1431" y="137.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-58-inside-16_4824_4737" fill="white">
      <path d="M1629 118H1794V174H1629V118Z" />
    </mask>
    <path d="M1629 118H1794V174H1629V118Z" fill="white" />
    <path
      d="M1794 118H1795V117H1794V118ZM1794 174V175H1795V174H1794ZM1629 119H1794V117H1629V119ZM1793 118V174H1795V118H1793ZM1794 173H1629V175H1794V173Z"
      fill="#E8E8E8"
      mask="url(#path-58-inside-16_4824_4737)"
    />
    <rect x="1663.5" y="137.5" width="92" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-61-inside-17_4824_4737" fill="white">
      <path d="M0 173H40V229H0V173Z" />
    </mask>
    <path d="M0 173H40V229H0V173Z" fill="white" />
    <path
      d="M0 173V172H-1V173H0ZM0 229H-1V230H0V229ZM0 174H40V172H0V174ZM40 228H0V230H40V228ZM1 229V173H-1V229H1Z"
      fill="#E6E6E6"
      mask="url(#path-61-inside-17_4824_4737)"
    />
    <rect
      x="12.5"
      y="193.5"
      width="15"
      height="15"
      rx="1.5"
      fill="white"
      stroke="#D6D5D5"
    />
    <mask id="path-64-inside-18_4824_4737" fill="white">
      <path d="M40 173H190V229H40V173Z" />
    </mask>
    <path d="M40 173H190V229H40V173Z" fill="white" />
    <path
      d="M40 174H190V172H40V174ZM190 228H40V230H190V228Z"
      fill="#E8E8E8"
      mask="url(#path-64-inside-18_4824_4737)"
    />
    <rect x="52" y="192.5" width="122" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-67-inside-19_4824_4737" fill="white">
      <path d="M190 173H1209V229H190V173Z" />
    </mask>
    <path d="M190 173H1209V229H190V173Z" fill="white" />
    <path
      d="M190 174H1209V172H190V174ZM1209 228H190V230H1209V228Z"
      fill="#E8E8E8"
      mask="url(#path-67-inside-19_4824_4737)"
    />
    <rect x="202" y="192.5" width="795" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-70-inside-20_4824_4737" fill="white">
      <path d="M1209 173H1419V229H1209V173Z" />
    </mask>
    <path d="M1209 173H1419V229H1209V173Z" fill="white" />
    <path
      d="M1209 174H1419V172H1209V174ZM1419 228H1209V230H1419V228Z"
      fill="#E8E8E8"
      mask="url(#path-70-inside-20_4824_4737)"
    />
    <rect x="1221" y="192.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-73-inside-21_4824_4737" fill="white">
      <path d="M1419 173H1629V229H1419V173Z" />
    </mask>
    <path d="M1419 173H1629V229H1419V173Z" fill="white" />
    <path
      d="M1419 174H1629V172H1419V174ZM1629 228H1419V230H1629V228Z"
      fill="#E8E8E8"
      mask="url(#path-73-inside-21_4824_4737)"
    />
    <rect x="1431" y="192.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-76-inside-22_4824_4737" fill="white">
      <path d="M1629 173H1794V229H1629V173Z" />
    </mask>
    <path d="M1629 173H1794V229H1629V173Z" fill="white" />
    <path
      d="M1794 173H1795V172H1794V173ZM1794 229V230H1795V229H1794ZM1629 174H1794V172H1629V174ZM1793 173V229H1795V173H1793ZM1794 228H1629V230H1794V228Z"
      fill="#E8E8E8"
      mask="url(#path-76-inside-22_4824_4737)"
    />
    <rect x="1663.5" y="192.5" width="92" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-79-inside-23_4824_4737" fill="white">
      <path d="M0 228H40V284H0V228Z" />
    </mask>
    <path d="M0 228H40V284H0V228Z" fill="white" />
    <path
      d="M0 228V227H-1V228H0ZM0 284H-1V285H0V284ZM0 229H40V227H0V229ZM40 283H0V285H40V283ZM1 284V228H-1V284H1Z"
      fill="#E6E6E6"
      mask="url(#path-79-inside-23_4824_4737)"
    />
    <rect
      x="12.5"
      y="248.5"
      width="15"
      height="15"
      rx="1.5"
      fill="white"
      stroke="#D6D5D5"
    />
    <mask id="path-82-inside-24_4824_4737" fill="white">
      <path d="M40 228H190V284H40V228Z" />
    </mask>
    <path d="M40 228H190V284H40V228Z" fill="white" />
    <path
      d="M40 229H190V227H40V229ZM190 283H40V285H190V283Z"
      fill="#E8E8E8"
      mask="url(#path-82-inside-24_4824_4737)"
    />
    <rect x="52" y="247.5" width="122" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-85-inside-25_4824_4737" fill="white">
      <path d="M190 228H1209V284H190V228Z" />
    </mask>
    <path d="M190 228H1209V284H190V228Z" fill="white" />
    <path
      d="M190 229H1209V227H190V229ZM1209 283H190V285H1209V283Z"
      fill="#E8E8E8"
      mask="url(#path-85-inside-25_4824_4737)"
    />
    <rect x="202" y="247.5" width="795" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-88-inside-26_4824_4737" fill="white">
      <path d="M1209 228H1419V284H1209V228Z" />
    </mask>
    <path d="M1209 228H1419V284H1209V228Z" fill="white" />
    <path
      d="M1209 229H1419V227H1209V229ZM1419 283H1209V285H1419V283Z"
      fill="#E8E8E8"
      mask="url(#path-88-inside-26_4824_4737)"
    />
    <rect x="1221" y="247.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-91-inside-27_4824_4737" fill="white">
      <path d="M1419 228H1629V284H1419V228Z" />
    </mask>
    <path d="M1419 228H1629V284H1419V228Z" fill="white" />
    <path
      d="M1419 229H1629V227H1419V229ZM1629 283H1419V285H1629V283Z"
      fill="#E8E8E8"
      mask="url(#path-91-inside-27_4824_4737)"
    />
    <rect x="1431" y="247.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-94-inside-28_4824_4737" fill="white">
      <path d="M1629 228H1794V284H1629V228Z" />
    </mask>
    <path d="M1629 228H1794V284H1629V228Z" fill="white" />
    <path
      d="M1794 228H1795V227H1794V228ZM1794 284V285H1795V284H1794ZM1629 229H1794V227H1629V229ZM1793 228V284H1795V228H1793ZM1794 283H1629V285H1794V283Z"
      fill="#E8E8E8"
      mask="url(#path-94-inside-28_4824_4737)"
    />
    <rect x="1663.5" y="247.5" width="92" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-97-inside-29_4824_4737" fill="white">
      <path d="M0 283H40V339H0V283Z" />
    </mask>
    <path d="M0 283H40V339H0V283Z" fill="white" />
    <path
      d="M0 283V282H-1V283H0ZM0 339H-1V340H0V339ZM0 284H40V282H0V284ZM40 338H0V340H40V338ZM1 339V283H-1V339H1Z"
      fill="#E6E6E6"
      mask="url(#path-97-inside-29_4824_4737)"
    />
    <rect
      x="12.5"
      y="303.5"
      width="15"
      height="15"
      rx="1.5"
      fill="white"
      stroke="#D6D5D5"
    />
    <mask id="path-100-inside-30_4824_4737" fill="white">
      <path d="M40 283H190V339H40V283Z" />
    </mask>
    <path d="M40 283H190V339H40V283Z" fill="white" />
    <path
      d="M40 284H190V282H40V284ZM190 338H40V340H190V338Z"
      fill="#E8E8E8"
      mask="url(#path-100-inside-30_4824_4737)"
    />
    <rect x="52" y="302.5" width="122" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-103-inside-31_4824_4737" fill="white">
      <path d="M190 283H1209V339H190V283Z" />
    </mask>
    <path d="M190 283H1209V339H190V283Z" fill="white" />
    <path
      d="M190 284H1209V282H190V284ZM1209 338H190V340H1209V338Z"
      fill="#E8E8E8"
      mask="url(#path-103-inside-31_4824_4737)"
    />
    <rect x="202" y="302.5" width="795" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-106-inside-32_4824_4737" fill="white">
      <path d="M1209 283H1419V339H1209V283Z" />
    </mask>
    <path d="M1209 283H1419V339H1209V283Z" fill="white" />
    <path
      d="M1209 284H1419V282H1209V284ZM1419 338H1209V340H1419V338Z"
      fill="#E8E8E8"
      mask="url(#path-106-inside-32_4824_4737)"
    />
    <rect x="1221" y="302.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-109-inside-33_4824_4737" fill="white">
      <path d="M1419 283H1629V339H1419V283Z" />
    </mask>
    <path d="M1419 283H1629V339H1419V283Z" fill="white" />
    <path
      d="M1419 284H1629V282H1419V284ZM1629 338H1419V340H1629V338Z"
      fill="#E8E8E8"
      mask="url(#path-109-inside-33_4824_4737)"
    />
    <rect x="1431" y="302.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-112-inside-34_4824_4737" fill="white">
      <path d="M1629 283H1794V339H1629V283Z" />
    </mask>
    <path d="M1629 283H1794V339H1629V283Z" fill="white" />
    <path
      d="M1794 283H1795V282H1794V283ZM1794 339V340H1795V339H1794ZM1629 284H1794V282H1629V284ZM1793 283V339H1795V283H1793ZM1794 338H1629V340H1794V338Z"
      fill="#E8E8E8"
      mask="url(#path-112-inside-34_4824_4737)"
    />
    <rect x="1663.5" y="302.5" width="92" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-115-inside-35_4824_4737" fill="white">
      <path d="M0 338H40V394H0V338Z" />
    </mask>
    <path d="M0 338H40V394H0V338Z" fill="white" />
    <path
      d="M0 338V337H-1V338H0ZM0 394H-1V395H0V394ZM0 339H40V337H0V339ZM40 393H0V395H40V393ZM1 394V338H-1V394H1Z"
      fill="#E6E6E6"
      mask="url(#path-115-inside-35_4824_4737)"
    />
    <rect
      x="12.5"
      y="358.5"
      width="15"
      height="15"
      rx="1.5"
      fill="white"
      stroke="#D6D5D5"
    />
    <mask id="path-118-inside-36_4824_4737" fill="white">
      <path d="M40 338H190V394H40V338Z" />
    </mask>
    <path d="M40 338H190V394H40V338Z" fill="white" />
    <path
      d="M40 339H190V337H40V339ZM190 393H40V395H190V393Z"
      fill="#E8E8E8"
      mask="url(#path-118-inside-36_4824_4737)"
    />
    <rect x="52" y="357.5" width="122" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-121-inside-37_4824_4737" fill="white">
      <path d="M190 338H1209V394H190V338Z" />
    </mask>
    <path d="M190 338H1209V394H190V338Z" fill="white" />
    <path
      d="M190 339H1209V337H190V339ZM1209 393H190V395H1209V393Z"
      fill="#E8E8E8"
      mask="url(#path-121-inside-37_4824_4737)"
    />
    <rect x="202" y="357.5" width="795" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-124-inside-38_4824_4737" fill="white">
      <path d="M1209 338H1419V394H1209V338Z" />
    </mask>
    <path d="M1209 338H1419V394H1209V338Z" fill="white" />
    <path
      d="M1209 339H1419V337H1209V339ZM1419 393H1209V395H1419V393Z"
      fill="#E8E8E8"
      mask="url(#path-124-inside-38_4824_4737)"
    />
    <rect x="1221" y="357.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-127-inside-39_4824_4737" fill="white">
      <path d="M1419 338H1629V394H1419V338Z" />
    </mask>
    <path d="M1419 338H1629V394H1419V338Z" fill="white" />
    <path
      d="M1419 339H1629V337H1419V339ZM1629 393H1419V395H1629V393Z"
      fill="#E8E8E8"
      mask="url(#path-127-inside-39_4824_4737)"
    />
    <rect x="1431" y="357.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-130-inside-40_4824_4737" fill="white">
      <path d="M1629 338H1794V394H1629V338Z" />
    </mask>
    <path d="M1629 338H1794V394H1629V338Z" fill="white" />
    <path
      d="M1794 338H1795V337H1794V338ZM1794 394V395H1795V394H1794ZM1629 339H1794V337H1629V339ZM1793 338V394H1795V338H1793ZM1794 393H1629V395H1794V393Z"
      fill="#E8E8E8"
      mask="url(#path-130-inside-40_4824_4737)"
    />
    <rect x="1663.5" y="357.5" width="92" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-133-inside-41_4824_4737" fill="white">
      <path d="M0 393H40V449H0V393Z" />
    </mask>
    <path d="M0 393H40V449H0V393Z" fill="white" />
    <path
      d="M0 393V392H-1V393H0ZM0 449H-1V450H0V449ZM0 394H40V392H0V394ZM40 448H0V450H40V448ZM1 449V393H-1V449H1Z"
      fill="#E6E6E6"
      mask="url(#path-133-inside-41_4824_4737)"
    />
    <rect
      x="12.5"
      y="413.5"
      width="15"
      height="15"
      rx="1.5"
      fill="white"
      stroke="#D6D5D5"
    />
    <mask id="path-136-inside-42_4824_4737" fill="white">
      <path d="M40 393H190V449H40V393Z" />
    </mask>
    <path d="M40 393H190V449H40V393Z" fill="white" />
    <path
      d="M40 394H190V392H40V394ZM190 448H40V450H190V448Z"
      fill="#E8E8E8"
      mask="url(#path-136-inside-42_4824_4737)"
    />
    <rect x="52" y="412.5" width="122" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-139-inside-43_4824_4737" fill="white">
      <path d="M190 393H1209V449H190V393Z" />
    </mask>
    <path d="M190 393H1209V449H190V393Z" fill="white" />
    <path
      d="M190 394H1209V392H190V394ZM1209 448H190V450H1209V448Z"
      fill="#E8E8E8"
      mask="url(#path-139-inside-43_4824_4737)"
    />
    <rect x="202" y="412.5" width="795" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-142-inside-44_4824_4737" fill="white">
      <path d="M1209 393H1419V449H1209V393Z" />
    </mask>
    <path d="M1209 393H1419V449H1209V393Z" fill="white" />
    <path
      d="M1209 394H1419V392H1209V394ZM1419 448H1209V450H1419V448Z"
      fill="#E8E8E8"
      mask="url(#path-142-inside-44_4824_4737)"
    />
    <rect x="1221" y="412.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-145-inside-45_4824_4737" fill="white">
      <path d="M1419 393H1629V449H1419V393Z" />
    </mask>
    <path d="M1419 393H1629V449H1419V393Z" fill="white" />
    <path
      d="M1419 394H1629V392H1419V394ZM1629 448H1419V450H1629V448Z"
      fill="#E8E8E8"
      mask="url(#path-145-inside-45_4824_4737)"
    />
    <rect x="1431" y="412.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-148-inside-46_4824_4737" fill="white">
      <path d="M1629 393H1794V449H1629V393Z" />
    </mask>
    <path d="M1629 393H1794V449H1629V393Z" fill="white" />
    <path
      d="M1794 393H1795V392H1794V393ZM1794 449V450H1795V449H1794ZM1629 394H1794V392H1629V394ZM1793 393V449H1795V393H1793ZM1794 448H1629V450H1794V448Z"
      fill="#E8E8E8"
      mask="url(#path-148-inside-46_4824_4737)"
    />
    <rect x="1663.5" y="412.5" width="92" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-151-inside-47_4824_4737" fill="white">
      <path d="M0 448H40V504H0V448Z" />
    </mask>
    <path d="M0 448H40V504H0V448Z" fill="white" />
    <path
      d="M0 448V447H-1V448H0ZM0 504H-1V505H0V504ZM0 449H40V447H0V449ZM40 503H0V505H40V503ZM1 504V448H-1V504H1Z"
      fill="#E6E6E6"
      mask="url(#path-151-inside-47_4824_4737)"
    />
    <rect
      x="12.5"
      y="468.5"
      width="15"
      height="15"
      rx="1.5"
      fill="white"
      stroke="#D6D5D5"
    />
    <mask id="path-154-inside-48_4824_4737" fill="white">
      <path d="M40 448H190V504H40V448Z" />
    </mask>
    <path d="M40 448H190V504H40V448Z" fill="white" />
    <path
      d="M40 449H190V447H40V449ZM190 503H40V505H190V503Z"
      fill="#E8E8E8"
      mask="url(#path-154-inside-48_4824_4737)"
    />
    <rect x="52" y="467.5" width="122" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-157-inside-49_4824_4737" fill="white">
      <path d="M190 448H1209V504H190V448Z" />
    </mask>
    <path d="M190 448H1209V504H190V448Z" fill="white" />
    <path
      d="M190 449H1209V447H190V449ZM1209 503H190V505H1209V503Z"
      fill="#E8E8E8"
      mask="url(#path-157-inside-49_4824_4737)"
    />
    <rect x="202" y="467.5" width="795" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-160-inside-50_4824_4737" fill="white">
      <path d="M1209 448H1419V504H1209V448Z" />
    </mask>
    <path d="M1209 448H1419V504H1209V448Z" fill="white" />
    <path
      d="M1209 449H1419V447H1209V449ZM1419 503H1209V505H1419V503Z"
      fill="#E8E8E8"
      mask="url(#path-160-inside-50_4824_4737)"
    />
    <rect x="1221" y="467.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-163-inside-51_4824_4737" fill="white">
      <path d="M1419 448H1629V504H1419V448Z" />
    </mask>
    <path d="M1419 448H1629V504H1419V448Z" fill="white" />
    <path
      d="M1419 449H1629V447H1419V449ZM1629 503H1419V505H1629V503Z"
      fill="#E8E8E8"
      mask="url(#path-163-inside-51_4824_4737)"
    />
    <rect x="1431" y="467.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-166-inside-52_4824_4737" fill="white">
      <path d="M1629 448H1794V504H1629V448Z" />
    </mask>
    <path d="M1629 448H1794V504H1629V448Z" fill="white" />
    <path
      d="M1794 448H1795V447H1794V448ZM1794 504V505H1795V504H1794ZM1629 449H1794V447H1629V449ZM1793 448V504H1795V448H1793ZM1794 503H1629V505H1794V503Z"
      fill="#E8E8E8"
      mask="url(#path-166-inside-52_4824_4737)"
    />
    <rect x="1663.5" y="467.5" width="92" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-169-inside-53_4824_4737" fill="white">
      <path d="M0 503H40V559H0V503Z" />
    </mask>
    <path d="M0 503H40V559H0V503Z" fill="white" />
    <path
      d="M0 503V502H-1V503H0ZM0 559H-1V560H0V559ZM0 504H40V502H0V504ZM40 558H0V560H40V558ZM1 559V503H-1V559H1Z"
      fill="#E6E6E6"
      mask="url(#path-169-inside-53_4824_4737)"
    />
    <rect
      x="12.5"
      y="523.5"
      width="15"
      height="15"
      rx="1.5"
      fill="white"
      stroke="#D6D5D5"
    />
    <mask id="path-172-inside-54_4824_4737" fill="white">
      <path d="M40 503H190V559H40V503Z" />
    </mask>
    <path d="M40 503H190V559H40V503Z" fill="white" />
    <path
      d="M40 504H190V502H40V504ZM190 558H40V560H190V558Z"
      fill="#E8E8E8"
      mask="url(#path-172-inside-54_4824_4737)"
    />
    <rect x="52" y="522.5" width="122" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-175-inside-55_4824_4737" fill="white">
      <path d="M190 503H1209V559H190V503Z" />
    </mask>
    <path d="M190 503H1209V559H190V503Z" fill="white" />
    <path
      d="M190 504H1209V502H190V504ZM1209 558H190V560H1209V558Z"
      fill="#E8E8E8"
      mask="url(#path-175-inside-55_4824_4737)"
    />
    <rect x="202" y="522.5" width="795" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-178-inside-56_4824_4737" fill="white">
      <path d="M1209 503H1419V559H1209V503Z" />
    </mask>
    <path d="M1209 503H1419V559H1209V503Z" fill="white" />
    <path
      d="M1209 504H1419V502H1209V504ZM1419 558H1209V560H1419V558Z"
      fill="#E8E8E8"
      mask="url(#path-178-inside-56_4824_4737)"
    />
    <rect x="1221" y="522.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-181-inside-57_4824_4737" fill="white">
      <path d="M1419 503H1629V559H1419V503Z" />
    </mask>
    <path d="M1419 503H1629V559H1419V503Z" fill="white" />
    <path
      d="M1419 504H1629V502H1419V504ZM1629 558H1419V560H1629V558Z"
      fill="#E8E8E8"
      mask="url(#path-181-inside-57_4824_4737)"
    />
    <rect x="1431" y="522.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-184-inside-58_4824_4737" fill="white">
      <path d="M1629 503H1794V559H1629V503Z" />
    </mask>
    <path d="M1629 503H1794V559H1629V503Z" fill="white" />
    <path
      d="M1794 503H1795V502H1794V503ZM1794 559V560H1795V559H1794ZM1629 504H1794V502H1629V504ZM1793 503V559H1795V503H1793ZM1794 558H1629V560H1794V558Z"
      fill="#E8E8E8"
      mask="url(#path-184-inside-58_4824_4737)"
    />
    <rect x="1663.5" y="522.5" width="92" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-187-inside-59_4824_4737" fill="white">
      <path d="M0 558H40V614H0V558Z" />
    </mask>
    <path d="M0 558H40V614H0V558Z" fill="white" />
    <path
      d="M0 558V557H-1V558H0ZM0 614H-1V615H0V614ZM0 559H40V557H0V559ZM40 613H0V615H40V613ZM1 614V558H-1V614H1Z"
      fill="#E6E6E6"
      mask="url(#path-187-inside-59_4824_4737)"
    />
    <rect
      x="12.5"
      y="578.5"
      width="15"
      height="15"
      rx="1.5"
      fill="white"
      stroke="#D6D5D5"
    />
    <mask id="path-190-inside-60_4824_4737" fill="white">
      <path d="M40 558H190V614H40V558Z" />
    </mask>
    <path d="M40 558H190V614H40V558Z" fill="white" />
    <path
      d="M40 559H190V557H40V559ZM190 613H40V615H190V613Z"
      fill="#E8E8E8"
      mask="url(#path-190-inside-60_4824_4737)"
    />
    <rect x="52" y="577.5" width="122" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-193-inside-61_4824_4737" fill="white">
      <path d="M190 558H1209V614H190V558Z" />
    </mask>
    <path d="M190 558H1209V614H190V558Z" fill="white" />
    <path
      d="M190 559H1209V557H190V559ZM1209 613H190V615H1209V613Z"
      fill="#E8E8E8"
      mask="url(#path-193-inside-61_4824_4737)"
    />
    <rect x="202" y="577.5" width="795" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-196-inside-62_4824_4737" fill="white">
      <path d="M1209 558H1419V614H1209V558Z" />
    </mask>
    <path d="M1209 558H1419V614H1209V558Z" fill="white" />
    <path
      d="M1209 559H1419V557H1209V559ZM1419 613H1209V615H1419V613Z"
      fill="#E8E8E8"
      mask="url(#path-196-inside-62_4824_4737)"
    />
    <rect x="1221" y="577.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-199-inside-63_4824_4737" fill="white">
      <path d="M1419 558H1629V614H1419V558Z" />
    </mask>
    <path d="M1419 558H1629V614H1419V558Z" fill="white" />
    <path
      d="M1419 559H1629V557H1419V559ZM1629 613H1419V615H1629V613Z"
      fill="#E8E8E8"
      mask="url(#path-199-inside-63_4824_4737)"
    />
    <rect x="1431" y="577.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-202-inside-64_4824_4737" fill="white">
      <path d="M1629 558H1794V614H1629V558Z" />
    </mask>
    <path d="M1629 558H1794V614H1629V558Z" fill="white" />
    <path
      d="M1794 558H1795V557H1794V558ZM1794 614V615H1795V614H1794ZM1629 559H1794V557H1629V559ZM1793 558V614H1795V558H1793ZM1794 613H1629V615H1794V613Z"
      fill="#E8E8E8"
      mask="url(#path-202-inside-64_4824_4737)"
    />
    <rect x="1663.5" y="577.5" width="92" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-205-inside-65_4824_4737" fill="white">
      <path d="M0 613H40V669H0V613Z" />
    </mask>
    <path d="M0 613H40V669H0V613Z" fill="white" />
    <path
      d="M0 613V612H-1V613H0ZM0 669H-1V670H0V669ZM0 614H40V612H0V614ZM40 668H0V670H40V668ZM1 669V613H-1V669H1Z"
      fill="#E6E6E6"
      mask="url(#path-205-inside-65_4824_4737)"
    />
    <rect
      x="12.5"
      y="633.5"
      width="15"
      height="15"
      rx="1.5"
      fill="white"
      stroke="#D6D5D5"
    />
    <mask id="path-208-inside-66_4824_4737" fill="white">
      <path d="M40 613H190V669H40V613Z" />
    </mask>
    <path d="M40 613H190V669H40V613Z" fill="white" />
    <path
      d="M40 614H190V612H40V614ZM190 668H40V670H190V668Z"
      fill="#E8E8E8"
      mask="url(#path-208-inside-66_4824_4737)"
    />
    <rect x="52" y="632.5" width="122" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-211-inside-67_4824_4737" fill="white">
      <path d="M190 613H1209V669H190V613Z" />
    </mask>
    <path d="M190 613H1209V669H190V613Z" fill="white" />
    <path
      d="M190 614H1209V612H190V614ZM1209 668H190V670H1209V668Z"
      fill="#E8E8E8"
      mask="url(#path-211-inside-67_4824_4737)"
    />
    <rect x="202" y="632.5" width="795" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-214-inside-68_4824_4737" fill="white">
      <path d="M1209 613H1419V669H1209V613Z" />
    </mask>
    <path d="M1209 613H1419V669H1209V613Z" fill="white" />
    <path
      d="M1209 614H1419V612H1209V614ZM1419 668H1209V670H1419V668Z"
      fill="#E8E8E8"
      mask="url(#path-214-inside-68_4824_4737)"
    />
    <rect x="1221" y="632.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-217-inside-69_4824_4737" fill="white">
      <path d="M1419 613H1629V669H1419V613Z" />
    </mask>
    <path d="M1419 613H1629V669H1419V613Z" fill="white" />
    <path
      d="M1419 614H1629V612H1419V614ZM1629 668H1419V670H1629V668Z"
      fill="#E8E8E8"
      mask="url(#path-217-inside-69_4824_4737)"
    />
    <rect x="1431" y="632.5" width="159" height="17" rx="8.5" fill="#F0F0F0" />
    <mask id="path-220-inside-70_4824_4737" fill="white">
      <path d="M1629 613H1794V669H1629V613Z" />
    </mask>
    <path d="M1629 613H1794V669H1629V613Z" fill="white" />
    <path
      d="M1794 613H1795V612H1794V613ZM1794 669V670H1795V669H1794ZM1629 614H1794V612H1629V614ZM1793 613V669H1795V613H1793ZM1794 668H1629V670H1794V668Z"
      fill="#E8E8E8"
      mask="url(#path-220-inside-70_4824_4737)"
    />
    <rect x="1663.5" y="632.5" width="92" height="17" rx="8.5" fill="#F0F0F0" />
    <defs>
      <clipPath id="clip0_4824_4737">
        <rect
          width="11.823"
          height="6.84273"
          fill="white"
          transform="translate(1489.06 17.9646) rotate(90)"
        />
      </clipPath>
      <clipPath id="clip1_4824_4737">
        <rect
          width="11.823"
          height="6.84273"
          fill="white"
          transform="translate(1493.66 17.9646) rotate(90)"
        />
      </clipPath>
      <clipPath id="clip2_4824_4737">
        <rect
          width="11.823"
          height="6.84273"
          fill="white"
          transform="translate(1522.84 18) rotate(90)"
        />
      </clipPath>
      <clipPath id="clip3_4824_4737">
        <rect
          width="11.823"
          height="6.84273"
          fill="white"
          transform="matrix(4.37114e-08 1 1 -4.37114e-08 1730.16 18)"
        />
      </clipPath>
      <clipPath id="clip4_4824_4737">
        <rect
          width="11.823"
          height="6.84273"
          fill="white"
          transform="matrix(4.37114e-08 1 1 -4.37114e-08 1763.94 17.9646)"
        />
      </clipPath>
      <clipPath id="clip5_4824_4737">
        <rect
          width="11.823"
          height="6.84273"
          fill="white"
          transform="matrix(4.37114e-08 1 1 -4.37114e-08 1759.34 17.9646)"
        />
      </clipPath>
    </defs>
  </svg>
);
